import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export const AGENT_LABEL = { advisor: "AI Advisor", cover_letter: "Cover Letter", orientation: "Orientation", predictor: "Predictor", cv: "CV Writer" };

export const FREEMIUM_TOOLS = [
  { key: "advisor", label: "AI Advisor", path: "/agent" },
  { key: "cover_letter", label: "Cover Letter", path: "/tools/cover-letter" },
  { key: "orientation", label: "Orientation", path: "/tools/orientation" },
  { key: "predictor", label: "Admission Predictor", path: "/tools/predictor" },
];

export const LEVELS = [
  { key: "undergraduate", label: "Undergraduate" },
  { key: "postgraduate", label: "Postgraduate" },
];

export function Stat({ icon: Icon, label, value, hint }) {
  return (
    <Card className="p-5 rounded-2xl border-border">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-orange/10 flex items-center justify-center shrink-0"><Icon className="h-5 w-5 text-orange" /></div>
        <div className="min-w-0">
          <div className="text-2xl font-display font-extrabold italic text-navy leading-none">{value}</div>
          <div className="text-xs text-muted-foreground mt-1">{label}</div>
        </div>
      </div>
      {hint && <div className="text-[11px] text-muted-foreground mt-3">{hint}</div>}
    </Card>
  );
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text; document.body.appendChild(ta); ta.select();
    try { document.execCommand("copy"); } catch (_) { /* noop */ }
    document.body.removeChild(ta);
  }
  toast.success("Copied to clipboard");
}
